import React, { useEffect, useMemo, useState } from "react";
import { connect } from "react-redux";
import {
  Button,
  Grid,
  TextField,
  makeStyles,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@material-ui/core";
import AddIcon from "@material-ui/icons/Add";
import FileCopyIcon from "@material-ui/icons/FileCopy";
import ContentPasteIcon from "@material-ui/icons/Assignment";
import DeleteIcon from "@material-ui/icons/Delete";
import CircularProgress from "@material-ui/core/CircularProgress";
import CustomButton from "./CustomButton";
import GridSelect from "./Grid/GridSelect";
import * as ruleAction from "../../../actions/ruleAction";
import * as miscAction from "../../../actions/miscAction";
import * as _ from "lodash";
import AutoCompleteDropdown from "./AutoCompleteDropDown";
import AutocompleteSelect from "./AutoCompleteSelect";
import SearchableList from "./SearchableList";
import DropdownSelect from "./DropDownSelect";
import WarningPopup from "./warningPopup";
import { injectIntlTranslation } from "@carrier-ecat/workflowui-globalfunctions";
import { injectIntl } from "react-intl";
import { constants } from "../../../constants/constants";

const windowHeight = window.innerHeight;

const Rules = ({
  rulesState,
  miscState,
  title,
  subTitle,
  updateRules,
  setSnackBar,
  rules,
  dataDescriptionState,
  createNewRule,
  onCloseSelected,
  setIsUnsaveChanges = (d) => {},
  setKeepRules = (d) => {},
  copyDrawing = null,
  backupRules = [],
  intl,
  setCopyState,
  copyState,
  msgConfig = false,
}) => {
  const useStyles = makeStyles((theme) => ({
    paper: {
      position: "absolute",
      backgroundColor: theme.palette.background.paper,
      marginTop: "50px",
    },
    container: {
      border: "1px solid var(--Brand-color-Light-Grey, #E5E7ED)",
      borderRadius: "4px",
      margin: "0 4px",
      marginBottom: "5px",
    },
    gridHeaderColumns: {
      width: "100%",
      display: "grid",
      gridTemplateColumns: "10% 40% 20% 20% 10%",
    },
    gridColumns: {
      width: "100%",
      display: "grid",
      gridTemplateColumns: "10% 90%",
    },
    divColumnHeader: {
      width: "100%",
      display: "grid",
      alignItems: "center",
      gridTemplateColumns: "40% 25% 25% 10%",
      marginBottom: "8px",
    },
    divColumn: {
      width: "100%",
      display: "grid",
      alignItems: "center",
      gridTemplateColumns: "40% 25% 25% 10%",
      border: "1px solid var(--Brand-color-Light-Grey, #E5E7ED);",
      paddingLeft: "4px",
      marginBottom: "4px",
    },
    item: {
      textAlign: "left",
      fontSize: "12px",
    },
    andIcon: {
      color: "#BAC0D0",
      fontSize: "16px",
    },
    addNewRule: {
      color: "#1891F6",
      fontSize: "12px",
      fontWeight: "700",
      border: "none",
      backgroundColor: "transparent",
      margin: "0 auto",
      display: "flex",
      alignItems: "center",
      gap: "8px",
    },
    header: {
      fontSize: "14px",
      fontWeight: "500",
    },
  }));

  const classes = useStyles();

  const [fields, setFields] = useState([]);
  const [loading, setLoading] = useState(false);
  const [showDelete, setShowDelete] = useState(false);
  const [selectedRule, setSelectedRule] = useState();
  const [deleteFlag, setDeleteFlag] = useState("");
  const [deleteRule, setDeleteRule] = useState([]);
  const [deleteDependencies, setDeleteDependencies] = useState([]);
  const [updateDrawingDependency, setUpdateDrawingDependency] = useState([]);
  const [index, setIndex] = useState(0);
  const [ruleIndex, setRuleIndex] = useState(0);

  const [ddList, setDDlist] = useState([]);

  const prepareRuleLayerRequest = (updateDrawingDependencyRequests) => {
    const rulesInfo = [...rulesState?.drawingRules?.data?.drawingRules];
    const oldData = [];
    rulesInfo.length > 0 &&
      rulesInfo.forEach(async (item, index) => {
        if (item.drawingRuleId !== "") {
          item.drawingDependencies &&
            item.drawingDependencies.length > 0 &&
            item.drawingDependencies.forEach(async (newItem) => {
              const isEmpty = newItem?.id.includes("dep");
              if (newItem?.id !== "") {
                let payload = {
                  ddName: newItem.ddName,
                  minValue: newItem.minValue,
                  maxValue: newItem.maxValue,
                  drawingRuleId: newItem.dwgRuleId,
                  drawingDependencyId: newItem?.id,
                  modelId: rules?.modelId,
                };
                oldData.push(payload);
              }
            });
        }
      });
    const difference = _.differenceWith(
      updateDrawingDependencyRequests,
      oldData,
      _.isEqual
    );
    return difference;
  };

  /* Save action */
  const onCreateValue = async () => {
    try {
      const gridData = JSON.parse(JSON.stringify(fields));
      const createDrawingRuleRequest = [];
      let createDrawingDependencyRequests = [];
      let createDrawingDependencyRequestsWithRule = [];
      const updateDrawingDependencyRequests = [];

      gridData.length > 0 &&
        gridData.forEach(async (item, index) => {
          createDrawingDependencyRequests = [];
          if (item.drawingRuleId === "") {
            item.drawingDependencies &&
              item.drawingDependencies.length > 0 &&
              item.drawingDependencies.forEach(async (newItem) => {
                const isEmpty = newItem?.id.includes("dep");
                if (isEmpty) {
                  let payload = {
                    ddName: newItem.ddName,
                    minValue: newItem.minValue,
                    maxValue: newItem.maxValue,
                    drawingRuleId: "00000000-0000-0000-0000-000000000000",
                    modelId: newItem.ModelId,
                  };
                  createDrawingDependencyRequests.push(payload);
                }
              });
            createDrawingRuleRequest.push({
              createDrawingRuleRequest: {
                drawingId: rules?.drawingId,
              },
              createDrawingDependencyRequests: createDrawingDependencyRequests,
            });
          }
          if (item.drawingRuleId !== "") {
            //  createDrawingDependencyRequestsWithRule =[];
            item.drawingDependencies &&
              item.drawingDependencies.length > 0 &&
              item.drawingDependencies.forEach(async (newItem) => {
                const isEmpty = newItem?.id.includes("dep");
                if (isEmpty) {
                  let payload = {
                    ddName: newItem.ddName,
                    minValue: newItem.minValue,
                    maxValue: newItem.maxValue,
                    drawingRuleId: newItem.drawingRuleId,
                    modelId: newItem.ModelId,
                  };
                  createDrawingDependencyRequestsWithRule.push(payload);
                } else if (newItem?.id !== "") {
                  let payload = {
                    ddName: newItem.ddName,
                    minValue: newItem.minValue,
                    maxValue: newItem.maxValue,
                    drawingRuleId: newItem.dwgRuleId,
                    drawingDependencyId: newItem?.id,
                    modelId: rules?.modelId,
                  };
                  updateDrawingDependencyRequests.push(payload);
                }
              });
          }
        });
      const updatedValues = prepareRuleLayerRequest(
        updateDrawingDependencyRequests
      );
      const updateRequest = {
        drawingRuleRequest: {
          deleteDrawingRuleRequests: deleteRule,
          createDrawingRuleRequests: createDrawingRuleRequest,
        },
        drawingDependencyRequest: {
          deleteDrawingDependencyRequests: deleteDependencies,
          createDrawingDependencyRequests:
            createDrawingDependencyRequestsWithRule,
          updateDrawingDependencyRequests: updatedValues,
        },
        layerRequest: {
          createLayerRequests: [],
          deleteLayerRequests: [],
          updateLayerRequests: [],
        },
        layerRuleRequest: {
          deleteLayerRuleRequests: [],
          createLayerRuleRequests: [],
        },
        layerDependencyRequest: {
          deleteLayerDependencyRequests: [],
          createLayerDependencyRequests: [],
          updateLayerDependencyRequests: [],
        },
      };

      let deletedRulesIds = [];

      if (copyDrawing) {
        const rulesInfo = [...rulesState?.drawingRules?.data?.drawingRules];

        if (backupRules.length) {
          let t = backupRules.map((ele) => {
            return { drawingRuleId: ele.drawingRuleId };
          });
          // let deItem = updateRequest.drawingRuleRequest.deleteDrawingRuleRequests;
          deletedRulesIds = [
            ...t,
            ...updateRequest.drawingRuleRequest.deleteDrawingRuleRequests,
          ].map((e) => e.drawingRuleId);

          updateRequest.drawingRuleRequest.deleteDrawingRuleRequests = t;
        }

        let newRules = [];
        rulesInfo.forEach((ruleItem) => {
          let newCreateTemp = [];
          if (!deletedRulesIds.includes(ruleItem.drawingRuleId)) {
            let temp = ruleItem.drawingDependencies.map((ele) => {
              const { ddName, minValue, maxValue } = ele;
              let demoItem = {
                ddName,
                minValue,
                maxValue,
                drawingRuleId: "00000000-0000-0000-0000-000000000000",
                modelId: rules?.modelId,
              };

              updateRequest.drawingDependencyRequest.createDrawingDependencyRequests.forEach(
                (x) => {
                  // console.log("===: ", x, ele);
                  if (x.drawingRuleId === ele.dwgRuleId) {
                    // console.log(x);
                    newCreateTemp.push({
                      ddName: x.ddName,
                      minValue: x.minValue,
                      maxValue: x.maxValue,
                      drawingRuleId: "00000000-0000-0000-0000-000000000000",
                      modelId: rules?.modelId,
                    });
                  }
                }
              );

              updateRequest.drawingDependencyRequest.updateDrawingDependencyRequests.forEach(
                (x) => {
                  if (x.drawingDependencyId === ele.id) {
                    demoItem.minValue = x.minValue;
                    demoItem.maxValue = x.maxValue;
                  }
                }
              );

              return demoItem;
            });
            let temps = {
              createDrawingRuleRequest: { drawingId: rules?.drawingId },
              createDrawingDependencyRequests: [...temp, ...newCreateTemp],
            };
            newRules.push(temps);
          }
        });

        updateRequest.drawingDependencyRequest.createDrawingDependencyRequests =
          [];
        updateRequest.drawingDependencyRequest.updateDrawingDependencyRequests =
          [];
        updateRequest.drawingDependencyRequest.deleteDrawingDependencyRequests =
          [];

        updateRequest.drawingRuleRequest.createDrawingRuleRequests = [
          ...newRules,
          ...updateRequest.drawingRuleRequest.createDrawingRuleRequests,
        ];

        // console.log("New Request: ", updateRequest, rulesInfo);
      } else {
        const rulesInfo = [...rulesState?.drawingRules?.data?.drawingRules];

        // console.log(updateRequest, rulesInfo);
      }

      await updateRules(updateRequest);
      onCloseSelected({
        id: uuidv4(),
        isClosed: true,
      });
      if (!rulesState?.updateRules?.hasError) {
        setDeleteRule([]);
        setDeleteDependencies([]);
        setSnackBar(
          true,
          "success",
          injectIntlTranslation(intl, "saveSuccess", constants.saveSuccess)
        );
      }
    } catch (error) {
      setSnackBar(
        true,
        "error",
        injectIntlTranslation(
          intl,
          "somethingWentWrong",
          constants.somethingWentWrong
        )
      );
    }
  };

  useEffect(() => {
    window.onRuleSave = onCreateValue;
    window.getRuleData = () => {
      return JSON.parse(JSON.stringify(fields));
    };
  }, [fields]);

  /* Delete drawing rule action */
  const deleteConfirm = (flag, value, tabIndex, index) => {
    if (flag === "rule") {
      setIndex(tabIndex);
    } else if (flag === "dependencies") {
      setIndex(tabIndex);
      setRuleIndex(index);
    }
    setDeleteFlag(flag);
    setSelectedRule(value);
    setShowDelete(true);
  };

  const deleteItems = async () => {
    const gridData = [...fields];
    if (deleteFlag === "rule") {
      gridData.splice(index, 1);
      if (selectedRule.drawingRuleId !== "") {
        deleteRule.push({ drawingRuleId: selectedRule.drawingRuleId });
      }
      setDeleteRule(deleteRule);
    } else if (deleteFlag === "dependencies") {
      const isEmpty = selectedRule.id.includes("dep");
      gridData[index].drawingDependencies.splice(ruleIndex, 1);
      if (selectedRule.id && !isEmpty) {
        deleteDependencies.push({
          drawingDependencyId: selectedRule.id,
        });
      }
      setDeleteDependencies(deleteDependencies);
    }
    setShowDelete(false);
    setFields(gridData);
    setIsUnsaveChanges(gridData);
  };

  useEffect(() => {
    if (
      rulesState?.drawingRules?.data &&
      rulesState?.drawingRules?.data?.drawingRules
    ) {
      setFields(rulesState?.drawingRules?.data?.drawingRules);
      setKeepRules(rulesState?.drawingRules?.data?.drawingRules);
    }
  }, [rulesState?.drawingRules?.data?.drawingRules]);

  useEffect(() => {
    window.setRulesData = (data) => {
      setFields(data);
      setKeepRules(data);
    };
  }, []);

  useEffect(() => {
    setLoading(rulesState?.drawingRules?.isLoading);
  }, [rulesState?.drawingRules?.isLoading]);

  useEffect(() => {
    let configValues = dataDescriptionState?.gridData?.data;
    let list = [];
    if (configValues.length > 0) {
      configValues.forEach((item, index) => {
        list.push({
          label: item.ddName,
          value: index,
          ddValues: item.ddValues,
          columnType: item.columnType,
        });
      });
    }
    setDDlist(list);
  }, [dataDescriptionState?.gridData?.data]);

  const uuidv4 = () => {
    return "10000000-1000-4000-8000-100000000000".replace(/[018]/g, (c) =>
      (
        c ^
        (crypto.getRandomValues(new Uint8Array(1))[0] & (15 >> (c / 4)))
      ).toString(16)
    );
  };

  const handleNewField = (item, itemIndex) => {
    const gridData = JSON.parse(JSON.stringify(fields));
    const idText = "dep";
    const depId = idText.concat(uuidv4());
    const newItem = {
      ddName: "",
      minValue: "",
      maxValue: "",
      drawingRuleId: item?.drawingRuleId,
      ModelId: rules?.modelId,
      id: depId,
    };
    const updatedGrid = gridData.map((item, index) => {
      if (itemIndex === index) {
        return {
          ...item,
          drawingDependencies: item.drawingDependencies.concat(newItem),
        };
      }
      return item;
    });
    setFields(updatedGrid);
    setIsUnsaveChanges([...updatedGrid]);
    console.log("update object: ", updatedGrid);
  };

  const handleFieldChange =
    (itemIndex, index, fieldName, field, isDiscrete = false) =>
    (event) => {
      const newFields = JSON.parse(JSON.stringify(fields));
      const item = newFields[itemIndex].drawingDependencies;
      if (fieldName === "ddName") {
        item[index][fieldName] = event;
        item[index]["minValue"] = "";
        item[index]["maxValue"] = "";
      } else if (fieldName === "minValue" && !isDiscrete) {
        item[index][fieldName] = event;
      } else if (fieldName === "maxValue" && !isDiscrete) {
        item[index][fieldName] = event;
      } else if (fieldName === "" && !isDiscrete) {
        item[index][fieldName] = event;
      } else {
        item[index][fieldName] = event.target.value;
      }
      // console.log("New Update: ", newFields);
      setFields([...newFields]);
      // if (setIsUnsaveChanges) setIsUnsaveChanges([...newFields]);
      // console.log(event);
    };

  /* add new rule set */
  const handleNewRule = async () => {
    const gridData = JSON.parse(JSON.stringify(fields));
    const newItem = {
      drawingRuleId: "",
      drawingId: rules?.drawingId,
      drawingDependencies: [],
    };
    setFields([...gridData, newItem]);
    setIsUnsaveChanges([...gridData, newItem]);
  };

  const handlePasteRule = async () => {
    if (copyState) {
      const gridData = JSON.parse(JSON.stringify(fields));
      const copyFrom = JSON.parse(copyState.data);

      const idText = "dep";

      const d = {
        drawingRuleId: "",
        drawingId: copyFrom.drawingId,
        drawingDependencies: copyFrom?.drawingDependencies?.map((ele) => {
          const { ddName = "", minValue = "", maxValue = "" } = ele;
          return {
            ddName,
            minValue,
            maxValue,
            drawingRuleId: "",
            ModelId: rules?.modelId,
            id: idText?.concat(uuidv4()) || "",
          };
        }),
      };

      const newData = [...gridData, d];
      // console.log("New data: ", newData);
      setFields(newData);
      setIsUnsaveChanges(newData);
    }
  };

  const handleCopyClick = (id = "") => {
    if (id) {
      setCopyState({
        origin: "RULES",
        data: JSON.stringify(id),
      });
    }
  };

  const pasteBtn = useMemo(() => {
    return (
      <div
        style={{
          cursor: "pointer",
          marginright: "20px",
          color:
            copyState.data && copyState?.origin === "RULES"
              ? "rgb(14, 59, 141"
              : "gray",
          marginTop: "10px",
          pointerEvents:
            copyState.data && copyState?.origin === "RULES" ? "" : "none",
        }}
        onClick={handlePasteRule}
      >
        <ContentPasteIcon
          style={{
            width: "15px",
            height: "15px",
            marginRight: "3px",
            marginBottom: "-2px",
          }}
        />
        <span> {injectIntlTranslation(intl, "Paste", "Paste")}</span>
      </div>
    );
  }, [copyState]);

  return (
    <div className={"rules-wrapper"} style={{ paddingTop: "25px" }}>
      <div style={{ display: "flex", width: "100%" }}>
        <div style={{ flex: "1" }} className="drawing-header">
          {injectIntlTranslation(intl, "rulesText", constants.rulesText)}
        </div>
        {pasteBtn}
        <Button
          onClick={() => handleNewRule()}
          className="newrule"
          startIcon={<AddIcon fontSize="small" />}
        >
          {injectIntlTranslation(
            intl,
            "newRuleSetBtn",
            constants.newRuleSetBtn
          )}
        </Button>
      </div>
      <span id="simple-modal-sub-title" style={{ color: "#617080" }}>
        {subTitle}
      </span>
      <div
        className="inner-wrapper"
        style={{
          height: `calc(100vh - 300px)`,
          overflow: "auto",
          overflowX: "hidden",
        }}
      >
        {loading && ""}

        {!loading &&
          fields.length > 0 &&
          fields.map((item, itemIndex) => {
            return (
              <div
                style={{
                  textAlign: "center",
                  scrollBehavior: "auto",
                  // overflow: "hidden",
                  // overflowX: "hidden",
                  // height: "calc(100vh - 450px)",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    textAlign: "right",
                    gap: "10px",
                    fontSize: "14px",
                    width: "100%",
                    color: "rgb(14, 59, 141)",
                    marginBottom: "5px",
                  }}
                >
                  <div
                    style={{ marginLeft: "auto", cursor: "pointer" }}
                    onClick={() => {
                      handleCopyClick(item);
                    }}
                  >
                    <FileCopyIcon
                      style={{
                        width: "15px",
                        height: "15px",
                        marginRight: "3px",
                        marginBottom: "-2px",
                      }}
                    />
                    <span>
                      {injectIntlTranslation(intl, "Copy All", "Copy All")}
                    </span>
                  </div>
                  {/* <div style={{ cursor: "pointer", marginLeft: "10px", color: "gray" }}>
                    <ContentPasteIcon
                      style={{
                        width: "15px",
                        height: "15px",
                        marginRight: "3px",
                        marginBottom: "-2px",
                      }}
                    />
                    <span> Paste</span>
                  </div> */}
                </div>
                <Grid container spacing={1}>
                  <Grid
                    item
                    xs={12}
                    spacing={1}
                    container
                    className={classes.container}
                  >
                    <Grid
                      item
                      className={classes.gridColumns}
                      xs={12}
                      justify="center"
                      container
                      spacing={1}
                      alignItems="center"
                    >
                      <Grid
                        className={`${classes.header} ${classes.item}`}
                      ></Grid>
                      <div className={classes.divColumnHeader}>
                        <Grid
                          className={`${classes.header} ${classes.item}`}
                          item
                        >
                          {injectIntlTranslation(
                            intl,
                            "DNameText",
                            constants.DNameText
                          )}
                        </Grid>
                        <Grid
                          className={`${classes.header} ${classes.item}`}
                          item
                        >
                          {injectIntlTranslation(intl, "min", constants.min)}
                        </Grid>
                        <Grid
                          className={`${classes.header} ${classes.item}`}
                          item
                        >
                          {injectIntlTranslation(intl, "max", constants.max)}
                        </Grid>
                        <Grid
                          className={`${classes.header} ${classes.item}`}
                          item
                        >
                          <DeleteIcon
                            fontSize="small"
                            style={{
                              marginLeft: "7px",
                            }}
                            onClick={() => {
                              deleteConfirm("rule", item, itemIndex);
                            }}
                          ></DeleteIcon>
                        </Grid>
                      </div>
                    </Grid>
                    <div className="rules">
                      {item?.drawingDependencies?.length > 0 &&
                        item?.drawingDependencies?.map((ruleItem, index) => {
                          var isDiscrete = false;
                          ddList.forEach((ele) => {
                            if (ele.label === ruleItem.ddName) {
                              isDiscrete = ele.columnType === "DISCRETE";
                            }
                          });

                          return (
                            <div>
                              <Grid
                                className={classes.gridColumns}
                                item
                                xs={12}
                                justify="center"
                                container
                                spacing={1}
                                alignItems="center"
                              >
                                <Grid
                                  item
                                  xs={1}
                                  className={`${classes.andIcon} ${classes.item}`}
                                >
                                  {index !== 0 && (
                                    <>
                                      {injectIntlTranslation(
                                        intl,
                                        "and",
                                        "and"
                                      )}
                                    </>
                                  )}
                                </Grid>
                                <div
                                  className={classes.divColumn}
                                  key={ruleItem.id}
                                  style={
                                    msgConfig ? { marginBottom: "12px" } : {}
                                  }
                                >
                                  <Grid
                                    item
                                    className={`${classes.item}`}
                                    xs={5}
                                  >
                                    {ddList.length && (
                                      <DropdownSelect
                                        size="small"
                                        tab="RulesLayer"
                                        id="outlined-basic"
                                        searchPlaceHolderText="Search for a DD Name"
                                        selectInfoText="Select a DD Name"
                                        selectedValue={ruleItem?.ddName}
                                        menuList={ddList}
                                        textWidth="100px"
                                        popperWidth="324px"
                                        popperHeight="211px"
                                        onChange={handleFieldChange(
                                          itemIndex,
                                          index,
                                          "ddName",
                                          ruleItem
                                        )}
                                      />
                                    )}
                                  </Grid>
                                  <Grid
                                    className={`${classes.item}`}
                                    item
                                    xs={3}
                                  >
                                    {isDiscrete ? (
                                      <TextField
                                        size="small"
                                        id="outlined-basic"
                                        placeholder=""
                                        label=""
                                        value={ruleItem.minValue}
                                        onChange={handleFieldChange(
                                          itemIndex,
                                          index,
                                          "minValue",
                                          ruleItem,
                                          isDiscrete
                                        )}
                                      />
                                    ) : (
                                      <AutocompleteSelect
                                        data={ddList}
                                        ddName={ruleItem?.ddName}
                                        value={ruleItem?.minValue}
                                        setIsUnsaveChanges={setIsUnsaveChanges}
                                        onChange={handleFieldChange(
                                          itemIndex,
                                          index,
                                          "minValue",
                                          ruleItem
                                        )}
                                      />
                                    )}
                                  </Grid>
                                  <Grid
                                    className={`${classes.item}`}
                                    item
                                    xs={3}
                                  >
                                    {isDiscrete ? (
                                      <TextField
                                        size="small"
                                        id="outlined-basic"
                                        placeholder=""
                                        label=""
                                        value={ruleItem.maxValue}
                                        onChange={handleFieldChange(
                                          itemIndex,
                                          index,
                                          "maxValue",
                                          ruleItem,
                                          isDiscrete
                                        )}
                                      />
                                    ) : (
                                      <AutocompleteSelect
                                        data={ddList}
                                        ddName={ruleItem?.ddName}
                                        value={ruleItem?.maxValue}
                                        setIsUnsaveChanges={setIsUnsaveChanges}
                                        onChange={handleFieldChange(
                                          itemIndex,
                                          index,
                                          "maxValue",
                                          ruleItem
                                        )}
                                      />
                                    )}
                                  </Grid>
                                  <Grid
                                    className={`${classes.item}`}
                                    item
                                    xs={1}
                                  >
                                    <DeleteIcon
                                      color="enabled"
                                      fontSize="small"
                                      onClick={() => {
                                        deleteConfirm(
                                          "dependencies",
                                          ruleItem,
                                          itemIndex,
                                          index
                                        );
                                      }}
                                    />
                                  </Grid>
                                </div>
                              </Grid>
                            </div>
                          );
                        })}
                      <Grid item style={{ margin: "0 auto" }}>
                        <Button
                          onClick={() => handleNewField(item, itemIndex)}
                          className={classes.addNewRule}
                          startIcon={<AddIcon fontSize="small" />}
                        >
                          {injectIntlTranslation(
                            intl,
                            "newRuleBtn",
                            constants.newRuleBtn
                          )}
                        </Button>
                      </Grid>
                    </div>
                  </Grid>
                  {itemIndex !== fields.length - 1 && (
                    <Grid
                      container
                      justify="center"
                      style={{ margin: "16px 0" }}
                    >
                      OR
                    </Grid>
                  )}
                </Grid>
              </div>
            );
          })}
      </div>

      <WarningPopup
        open={showDelete}
        onClose={() => setShowDelete(false)}
        title={injectIntlTranslation(
          intl,
          "deleteConfirmTitle",
          constants.deleteConfirmTitle
        )}
        description={
          <>
            {injectIntlTranslation(
              intl,
              "deleteConfirmText",
              constants.deleteConfirmText
            )}{" "}
            <b>{selectedRule?.ddName}</b>?
          </>
        }
        saveButtonLabel={injectIntlTranslation(
          intl,
          "deleteBtnLabel",
          constants.deleteBtnLabel
        )}
        onSave={() => {
          deleteItems();
        }}
      />
    </div>
  );
};

const mapStateToProps = (state) => ({
  rulesState: state.rules,
  miscState: state.misc,
  dataDescriptionState: state.data_description,
});

const mapDispatchToProps = (dispatch) => {
  return {
    getDrawingRules: async (id) => dispatch(ruleAction.getDrawingRules(id)),
    deleteRules: async (requestPayload) =>
      dispatch(ruleAction.deleteRules(requestPayload)),
    deleteRuleData: async (requestPayload) =>
      dispatch(ruleAction.deleteRuleData(requestPayload)),
    createRules: async (requestPayload) =>
      dispatch(ruleAction.createRules(requestPayload)),
    updateRules: async (requestPayload) =>
      dispatch(ruleAction.updateRules(requestPayload)),
    updateDrawingrRules: async (requestPayload) =>
      dispatch(ruleAction.updateDrawingrRules(requestPayload)),
    createNewRule: async (requestPayload) =>
      dispatch(ruleAction.createNewRule(requestPayload)),
    setSnackBar: (show, severity, message) =>
      dispatch(miscAction.setSnackBar(show, severity, message)),
    onCloseSelected: (data) => dispatch(miscAction.onCloseSelected(data)),
  };
};

export default injectIntl(connect(mapStateToProps, mapDispatchToProps)(Rules));
